module.exports = __webpack_public_path__ + "static/media/summer.56af34d8.jpeg";